import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class ValidarInscripcionCursadas extends Component {
  static displayName = ValidarInscripcionCursadas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      alumno: { codigo: '', descripcion: '' },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWInscripcionCursada');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.success) {
      this.setState({ errorMessage: '', success: false });
    }
  }

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupAnios: false,
      alumno: {
        codigo: carreraProperties[2],
        descripcion: carreraProperties[0] + ' - ' + carreraProperties[1],
      },
    });
  };

  isFormValid() {
    return this.state.alumno.descripcion.length > 1;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '', success: false });

    const { data } = await constantClass.apiFetch(
      'api/ic/changeStatusAll/' + this.state.alumno.codigo,
      { method: 'POST' }
    );

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron validar las inscripciones. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, success: true });
  }

  render() {
    const { loading, errorMessage, success, alumno, showLookupAnios } = this.state;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ic">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Validar Inscripciones</h1>
        <p className="md-form-page__subtitle">
          Seleccione un alumno para validar todas sus inscripciones pendientes.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {success && !loading ? (
                <span className="md-form-page__success">Validaciones realizadas exitosamente.</span>
              ) : null}
              {loading ? (
                <span className="md-form-page__loading">Validando inscripciones, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowAniosLookup}
                disabled={loading}
              >
                Seleccione el Alumno
              </button>
              {showLookupAnios ? (
                <LookupAlumnos
                  selectStudent={this.handleSelectAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.descripcion}
                placeholder="Alumno seleccionado"
                readOnly
                disabled
                aria-label="Alumno seleccionado"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Validar Inscripciones
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
